import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-4 animate-fade-in">
      <div className="text-center space-y-6 max-w-md">
        <AlertCircle className="w-20 h-20 text-primary mx-auto" />

        <h1 className="text-4xl font-bold text-foreground">404</h1>
        <h2 className="font-display text-2xl font-semibold text-foreground dark:text-muted-foreground">
          Page Not Found
        </h2>

        <p className="text-muted-foreground dark:text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Button
            variant="default"
            onClick={() => navigate(-1)}
            className="bg-primary hover:bg-primary/90"
          >
            Go Back
          </Button>

          <Button
            variant="outline"
            onClick={() => navigate("/")}
            className="border-primary text-primary hover:bg-primary/10"
          >
            Return Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
